import {
  findComponentByDisplayName
} from "./../../../../../store/constants/component_list";

export default function droppedComponent(name) {
  return findComponentByDisplayName(name).name;
}